import React from 'react';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
import Products from '../components/Products';
import Location from '../components/Location';

const Home = () => {
  return (
    <>
      <Hero />
      <AboutSection />
      <Products />
      <Location />
    </>
  );
};

export default Home;